import { useState, useEffect } from "react";
import labels from "../../../../config/labels";
import { TABLET_WIDE_WIDTH } from "../../../../config/constants";
import {
  componentResize,
  componentCheckSize,
  numberFormat,
  getCustomDate,
  getDisplayedRange
} from "../../../../utils/helperServices";
import { CustomContainer, Container, Row, Col, Modal } from "../../../atoms/DependencyHelper";
import PageHeading from "../../../atoms/pageHeading/PageHeading";
import ButtonGroup from "../../../molecules/buttonGroups/ButtonGroup";
import FilterButtons from "../../../molecules/filterButtons/FilterButtons";
import ButtonGroupOrderHistory from "../../buttonGroups/ButtonGroupOrderHistory";
import FilterNav from "../../../molecules/filterNav/FilterNav";
import SortContainer from "../../../organisms/SortContainer/SortContainer";
import LabelText from "../../../atoms/label/LabelText";
import DropDownComponent from "../../../atoms/dropDown/DropDown";

import styles from "./OrderHistoryTop.module.scss";

const OrderHistoryTop = (props) =>{
  const hideFilterOnMobile = true;
  const isTablet = componentCheckSize() <= TABLET_WIDE_WIDTH;
  let [sortProductsBy, setSortProductsBy] = useState("");
  let [sortByYear, setSortByYear] = useState("");
  let [featureSelected, setFeatureSelected] = useState("");
  const [showModal, SetShowModal] = useState(false);

  const FilterText = getDisplayedRange(props?.itemsLoaded, props?.totalItemsCount, labels.lbl_past_orders_found);

  const toggleHandler = (btnClicked) => {
    setFeatureSelected(btnClicked);
    btnClicked == 'sort' || btnClicked === "years" ? SetShowModal(true) : SetShowModal(false)
  };

  useEffect(() => {
    if(props?.resetFilter){
      setSortByYear("");
      setSortProductsBy("");
    }
  }, [props?.resetFilter]);

  const handleResetInMobile = (typeOfFilter) => {
    if(typeOfFilter === "sort") {
      setSortProductsBy("");
      props?.sortBy("");
    }
    if(typeOfFilter === "years") {
      setSortByYear("");
      props?.sortByYear("");
    }
  }

  const handleSelectedMobile = (flag, value = "", typeOfFilter) => {
    if (flag) {
      if(typeOfFilter === "sort") {
        setSortProductsBy(value);
        props?.sortBy(value);
      }
      if(typeOfFilter === "years") {
        setSortByYear(value);
        props?.sortByYear(value);
      }
    } else {
      handleResetInMobile(typeOfFilter);
    }
  };

  const handleSelected = (value) => {
    setSortProductsBy(value);
    props?.sortBy(value);
  };

  const handleSelectedYear = (value) => {
    setSortByYear(value);
    props?.sortByYear(value);
  };

  const checkSortModal = () => {
    SetShowModal(false);
    setFeatureSelected("");
  };

  const values = [
    { label: labels.sortKeys.lbl_new_to_old },
    { label: labels.sortKeys.lbl_old_to_new },
  ];

  const getYearsList = () => {
    const currentYear = new Date().getFullYear();
    const referenceYear = labels.lbl_reference_year;
    const years  = [{label: labels.lbl_all_years}];
    for(let i = currentYear; i>=referenceYear; i--) {
      years.push({label: i})
    }
    return years;
  }

  const handleSearch = (event) => {
    if(event.key === "Enter") {
      props?.handleSearchByOrderId(event.target.value);
      event?.target?.blur();
    }
  }

  const emptyOrderList = () => {
    if (props?.totalItemsCount > 0) {
      return "show";
    } else {
      return "hide";
    }
  }

  return (
    <Container className={`${styles['order-history-top']}`}>
      <Row className="mx-0">
        <Col className={`${styles['left-col']} pl-0 pr-0`} lg={6} md={12}>
          <PageHeading
            text={labels.lbl_order_history_header}
            level={1}
            variant="orderHistoryMainHeader"
            className={styles["orderHistoryMainHeader"]}
          />
          <CustomContainer className={`${styles['history-desc']} ${styles[emptyOrderList()]}`}>{labels.lbl_order_history_info}</CustomContainer>
        </Col>
        <Col className={`${styles['right-col']} ${styles[emptyOrderList()]} pl-0 pr-0`} lg={6} md={12}>
          <div className={`${styles["search"]} ${styles[props?.customTabletSearchClass]}`}>
            <input
              type="text"
              placeholder="Search using an order number"
              className={`${styles["coverage-search"]}`}
              onKeyPress = {(event) => handleSearch(event)}
              onChange={props?.handleChange}
              value={props?.searchOrderId}
            />
            {props?.noSearchFound ? <p className={`${styles["noSearchFound"]} mt-xs mb-0`}>{labels.lbl_no_results_found}</p> : ""}
          </div>
        </Col>
      </Row>
      {!isTablet ? (
          <Row className={`mb-3 pt-3 ${styles[emptyOrderList()]}`}>
            <LabelText
              className={`${styles["page-info"]} ${styles["page-info-text"]}`}>
              { FilterText }
            </LabelText>
            <CustomContainer
              className={`${styles["price-switch"]} ${
                !isTablet ? "product-list-container" : ""
              }`}
            >
              <>
                <LabelText
                  className={`${styles["page-info-text"]} ${styles["sort-by"]} d-inline-flex align-items-center`}
                >
                  {labels.lbl_years}:
                </LabelText>
                <DropDownComponent
                  data={getYearsList()}
                  handleSelect={handleSelectedYear}
                  selectedValue={
                    sortByYear === "" ? labels.lbl_all_years : sortByYear
                  }
                  customClass={styles["dropdown-item"]}
                  menuClassName="sort-menu"
                />
              </>
              <>
                <LabelText
                  className={`${styles["page-info-text"]} ${styles["sort-by"]} d-inline-flex align-items-center`}
                >
                  {labels.lbl_sort_by}:
                </LabelText>
                <DropDownComponent
                  data={values}
                  handleSelect={handleSelected}
                  selectedValue={
                    sortProductsBy === "" ? labels.sortKeys.lbl_new_to_old : sortProductsBy
                  }
                  customClass={styles["dropdown-item"]}
                  menuClassName="sort-menu"
                />
              </>
            </CustomContainer>
          </Row>
        )
        : !hideFilterOnMobile && (<CustomContainer className={`${styles["filter-btn"]} ${styles["custom-tablet-button"]} ${emptyOrderList()} filter-btn-group`}>
          <ButtonGroupOrderHistory
            toggleComps={(val) => {
              toggleHandler(val);
            }}
            selectedYearVal = {sortByYear!=="" ? sortByYear : labels.lbl_all_years}
            selectedSortVal={sortProductsBy!="" ? sortProductsBy : labels.sortKeys.lbl_new_to_old}
          />
        </CustomContainer>)
      }

      {featureSelected === "sort" ? (
        <Modal show={showModal} dialogClassName="select-modal">
          <div className={styles["sort-gutter"]}>
            <FilterNav
              headingName={labels.lbl_sort_by}
              backbtn={checkSortModal}
              resetClickHandler={() => handleResetInMobile('sort')}
            />
            {values.map((sortLabel, index) => (
              <SortContainer
                key={index}
                close={checkSortModal}
                boxHeading={sortLabel.label}
                selected={isTablet && sortProductsBy!=="" ? sortProductsBy === sortLabel.label : false}
                selectHandler={(flag) => handleSelectedMobile(flag, sortLabel.label, 'sort')}
              />
            ))}
          </div>
        </Modal>
      ): featureSelected === "years" && (
        <Modal show={showModal} dialogClassName="select-modal">
          <div className={styles["sort-gutter"]}>
            <FilterNav
              headingName="Years"
              backbtn={checkSortModal}
              resetClickHandler={() => handleResetInMobile('years')}
            />
            {getYearsList().map((year, index) => (
              <SortContainer
                key={index}
                close={checkSortModal}
                boxHeading={year.label}
                selected={isTablet && sortByYear!=="" ? sortByYear === year.label : false}
                selectHandler={(flag) => handleSelectedMobile(flag, year.label, 'years')}
              />
            ))}
          </div>
        </Modal>
      )}
    </Container>
  )
}

export default OrderHistoryTop;
